import React from "react";
import { Router, Route, IndexRoute } from "react-router";
import { history } from "./store.js";
import App from '../ui/App';
import Home from "../ui/pages/Home";
import Clients from "../ui/pages/Clients";
import About from "../ui/pages/About";
import Contact from "../ui/pages/Contact";
import NotFound from "../ui/pages/NotFound";



import Admin from "../ui/pages/Admin";

const router = (
	//<Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
  	<Router history={history}>
		<Route path="/" component={ App }>
			<IndexRoute component={ Home }/>
			<Route path="/clients" component={ Clients }/>
			<Route path="/about" component={ About }/>
			<Route path="/contact" component={ Contact }/>
			<Route path="*" component={ NotFound }/>
			<Route path="/admin" component={ Admin }/> //encrypted with keycloak
		</Route>
	</Router>
);

export { router };


// WEBPACK FOOTER //
// ./src/startup/router.js